/* global window */

const pageReload = () => {
  globalThis.location.reload();
};

export default pageReload;
